<ng-container *transloco="let t">
  <div class="consent-dialog-content__body">
    <beyond-online-headline size="xl" [headline]="t('consent.title')" />

    <p class="consent-dialog-content__paragraph">
      {{ t("consent.intro") }}
    </p>

    <p class="consent-dialog-content__paragraph">
      {{ t("consent.purpose-1") }}
      {{ t("consent.purpose-2")
      }}<a
        class="consent-dialog-content__link"
        href="https://www.zeiss.com/data-protection/en/home.html"
        target="_blank"
        rel="noopener noreferrer"
        >{{ t("consent.privacy-notice") }}</a
      >{{ t("consent.purpose-3") }}
    </p>

    <p class="consent-dialog-content__paragraph">
      {{ t("consent.transfer") }}
    </p>

    <p class="consent-dialog-content__paragraph">
      {{ t("consent.withdrawal-1")
      }}<a
        class="consent-dialog-content__link"
        href="https://www.zeiss.com/data-protection/en/contact.html"
        target="_blank"
        rel="noopener noreferrer"
        >{{ t("consent.principal-rights") }}</a
      >{{ t("consent.withdrawal-2") }}
    </p>

    <p
      class="consent-dialog-content__paragraph consent-dialog-content__contact"
    >
      {{ t("consent.contact-1")
      }}<a
        class="consent-dialog-content__link"
        href="mailto:dpo.in@zeiss.com"
        >{{ t("consent.contact-email") }}</a
      >{{ t("consent.contact-2") }}
    </p>
  </div>

  <div footer class="consent-dialog-content__footer">
    <button
      beyond-online-button
      type="button"
      variant="secondary"
      size="m"
      [label]="t('consent.decline')"
      (click)="onCancel()"
      [disabled]="isLoading()"
    ></button>

    <button
      beyond-online-button
      type="button"
      variant="primary"
      size="m"
      [label]="t('consent.accept')"
      (click)="onAgree()"
      [disabled]="isLoading()"
    ></button>
  </div>
</ng-container>
